import type { IMiniRequest } from './IMiniRequest';

let current: IMiniRequest | null = null;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

/**
 * Міні-форма поверх будь-якої сторінки (прототип v4 quickRec: заголовки й картка зв'язку матриці трасування, картки «Пов’язані записи»):
 * `open` показує міні-форму запису (її рендерить MiniFormHost оболонки), `close` — ховає. Живе в пам'яті сторінки.
 */
export const miniFormStore = {
  get: (): IMiniRequest | null => current,
  open: (request: IMiniRequest): void => { current = request; emit(); },
  close: (): void => { if (current) { current = null; emit(); } },
  subscribe: (listener: () => void): (() => void) => {
    listeners.add(listener);
    return () => { listeners.delete(listener); };
  },
};
